import useAuth from "./auth/useAuth.js";
import Login from './auth/Login.js';
import SearchBar from './support/SearchBar.js';
import useAnalytics from './support/Analytics.js';
import useSettings from './settings/useSettings.js';
import { useDarkMode } from './support/DarkModeContext';
import NavService from './navitems/NavService.js';
import { getRoute } from './support/Hijack.js';

import logo from '../media/logo.svg';
import logowhite from '../media/logo-white.png';
import logoHorizontal from '../media/logo-horizontal.svg';
import logoHorizontalWhite from '../media/logo-horizontal-white.png';
import MicrosoftLogo from './support/MicrosoftLogo.js';

import React, { useState, useEffect, useRef } from 'react';
import ListSubheader from '@material-ui/core/ListSubheader';
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import PersonIcon from '@material-ui/icons/Person';
import Box from '@material-ui/core/Box';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link, useLocation } from 'react-router-dom';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Typography from '@material-ui/core/Typography';
import Clear from '@material-ui/icons/Clear';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import ThemeToggle from './support/ThemeToggle';


const useStyles = makeStyles((theme) => ({
     toolbar: {
        borderBottom: 'none',
        padding: '30px 0 20px 0',
        display: 'none',
        alignItems: 'start',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
        "@media print": {
            display: "none !important"
        }
    },
    toolbarMobile: {
        display: 'flex',
        flexDirection: 'column',
        padding: '5px 0 20px 0',
        margin: '0',
        alignItems: 'start',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    toolbarRow: {
        width: '100%',
        display: 'flex',

    },
    toolbarLink: {
        padding: '0',
        flexShrink: '0',


    },
    toolbarLinkMobile: {
        paddingTop: 0,
        marginTop:0,
        alignItems: 'start',

    },
    fg: {
        flexGrow: "1"
    },
    logo: {
        height: '95px',
    },
    removePadding: {
        padding: '0'
    },
    removeMargin: {
        margin: '0'
    },
    searchBar: {        
        height: '30px'
    },
    selectedLink: {
        color: 'var(--red)'
    },
    searchText: {
        '& input': {
        fontFamily: "'Montserrat', Verdana, Geneva, sans-serif",
            color: 'var(--darkBlue)',
        fontWeight: '300',
        fontWeight: '700',
        fontSize: '.9rem',
        },
        '& input::placeholder': {
            color: 'var(--darkBlue)',
        }

    },
    iconLabel: {
        fontFamily: "'Montserrat', Verdana, Geneva, sans-serif",
        flexShrink: '0',
        color: "var(--darkBlue)",
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: ".9rem",
        textDecoration: "none",
        padding: '0 3px 5px 3px',
        borderRadius: 0,
        [theme.breakpoints.up('md')]: {
            padding: '4px 12px 4px 0px',
        },
        '&:hover': {
            color: "var(--red)",
            backgroundColor: "rgba(0, 0, 0, 0)",
            textDecoration: "none"
        },
        "&:focus-visible": {
            borderBottom: "2px solid var(--black)"
        }
    },
    menuUserName: {
        fontFamily: "'Montserrat', Verdana, Geneva, sans-serif",
        color: "var(--red)",
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: ".9rem",
        textDecoration: "none",
        margin: '0 12px 5px 12px',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    menuLabelHeading: {
        fontFamily: "'Montserrat', Verdana, Geneva, sans-serif",
        color: "var(--red)",
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: ".9rem",
        textDecoration: "none",
        display: "block",
        margin: '0 12px 0px 12px',
        '& a': {
            color: "var(--red)",
            '&:hover': {
                textDecoration: 'none'
            }
        }

    },
    menuLabel: {
        fontFamily: "'Montserrat', Verdana, Geneva, sans-serif",
        color: "var(--darkBlue)",
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: ".9rem",
        textDecoration: "none",
        display: "block",
        margin: '0 12px 0px 12px',
        '& a': {
            color: "var(--darkBlue)",
            '&:hover': {
                textDecoration: 'none'
            }
        },
        minHeight: "auto",
        paddingTop: "6px",
        paddingBottom: "6px"
 
    },
    menuLabelFlex: {
        display: "flex"
    },
    menuLabelIcon: {
        minWidth: "32px"
    },
    menuSubLabel: {
        fontSize: ".8rem",
        fontWeight: 400,
        marginLeft: "20px"
    },
    menuItem: {
        verticalAlign: "middle",
       '&::after': {
            content: '"|"',
            paddingLeft: "8px",
            color: "var(--darkBlue)",
           fontSize: "1.1em",
           display: "inline-block",
            marginTop: "-2px"
        }
    },
    menuItemWithMenu: {
        display: "inline-flex",
        alignItems: "center",
        padding: "0 !important",
        margin: "0 !important",
        boxSizing: "border-box",
        fontSize: "0.9rem !important",
        "&:hover": {
            background: "none"
        },
        "&:focus-visible": {
            borderBottom: "2px solid var(--black)"
        }
    },
    menuDesc: {
        fontFamily: "'Montserrat', Verdana, Geneva, sans-serif",
        color: "var(--darkGrey)",
        fontSize: ".8rem",
        textDecoration: "none",
        display: "block",
        margin: '0 12px 0px 12px',
        paddingLeft: '16px',
        paddingRight: '16px',
        minHeight: "auto"
    },    
    searchInputBox: {  
        borderBottom: '2px solid var(--red)',   
        marginTop: 0,
         '&::before': {             
             borderBottom: '2px solid var(--red)'
        },
        '&::after': {            
            borderBottom: '2px solid var(--red)'
        },
        '&::hover': {            
            borderBottom: '2px solid var(--red)'
        }

    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    sectionMobile: {
        display: 'block',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        '& > .MuiPaper-root': {
            padding: '1em',
            maxWidth: '75%',
            width: 'auto',
            display: 'block'
        }
    },
    navPopup: {
        borderTop: 'none',
        borderColor: 'var(--lightGrey)',
        paddingBottom: '15px'
    },
    b1: {
        display: "flex",
        justifyContent: "space-between"
    }
}));

export default function NavMenu(props) {
    const settings = useSettings();
    const [showSearch, setShowSearch] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [whichMenu, setWhichMenu] = React.useState('');
    const [filter, setFilter] = React.useState('');
    const [login, setLogin] = useState(false);
    const [showLogin, setShowLogin] = useState(0);
    const { isDarkMode, setIsDarkMode } = useDarkMode();

    let auth = useAuth();
    const [loadingSSO, setLoadingSSO] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showError, setShowError] = useState(false);
  
    const menuRef = useRef(0);

    const [navItems, setNavItems] = useState(NavService.cachedList);

    const classes = useStyles();
    let location = useLocation();
    let history = useHistory();
    const analytics = useAnalytics();
    const { sections, title } = props;
    const handleShowSearch = (e) => {
        setShowSearch(!showSearch);
    };
    const handleClick = (e, which) => {
        setAnchorEl(e.currentTarget);
        setWhichMenu(which);
    };  
    const handleClose = (e) => {
        setAnchorEl(null);
        setMobileOpen(false);
    };
    const handleLogout = () => {
        auth.signout(); 
        setAnchorEl(null);
    };
    const handleLogin = () => {
        setLogin(true);
        setAnchorEl(null);
    };
    const handleSearch = (search) => {
        analytics.tag('event', 'search', { search_term: search });
        history.push("/search?sort=score&filter=" + search);
        setShowSearch(false);
    };
    const onLogin = (success) => {
        if (success) {

        } else {

        }
        setLogin(false);
    };

    const [lastNavTime, setLastNavTime] = useState(0);
    useEffect(() => {
        var updated = settings.get("Nav last updated");
        if (lastNavTime != updated) {
            setLastNavTime(updated);
            NavService.getList({}, updated).then((response) => {
                setNavItems(response);
            });
        }
    }, [settings]);

    useEffect(() => {
        var pm = document.querySelectorAll("#popup-menu");
        for (var i = 0; i < pm.length; i++) {
            if (pm[i] != menuRef.current) {
                pm[i].parentNode.removeChild(pm[i]);
            }
        }
    }, []);
    
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const toggleMobile = (open) => (event) => {
        setMobileOpen(open);
    };

    function getReturnUrl() {
        var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
        if (baseUrl.length > 0 && baseUrl[baseUrl.length - 1] == "/")//strip trailing slash
            baseUrl = baseUrl.slice(0, baseUrl.length - 1);
        const origin = window.location.origin;
        const urlParams = new URLSearchParams(window.location.search);
        const originP = urlParams.get('origin');
        if (originP && originP !== "/login") {
            return `${origin}${originP}`;
        } else {
            return window.location.href;// `${origin}${baseUrl}`;
        }
    }

    const sso = () => {
        var returnUrl = getReturnUrl();
        setLoadingSSO(true);
        setTimeout(function () {
            auth.initSSO(returnUrl)
                .then((response) => {
                    setLoadingSSO(false);
                    setShowError(false);
                })
                .catch((error) => {
                    console.log(error);
                    setShowError(true);
                    if (error.response) {
                        setErrorMessage(error.response.data.message);
                    }
                    setLoadingSSO(false);
                });
        }, 500);

    };

    const renderMenuItem = (index, mobile = false) => {
        var el = null;
        var item = navItems[index];
        var route = item.url ? getRoute(item.url) : "";
        if (route !== false) {
            if (index !== navItems.length - 1 && navItems[index + 1].isChild && item.isChild == false) {
                if (!mobile) {
                    //desktop heading
                    el = <Button key={item.id} className={classes.menuItem + " " + classes.menuItemWithMenu} disableRipple
                        aria-controls="popup-menu" aria-haspopup="true" aria-label="open submenu"
                        onClick={(e) => handleClick(e, index)}>{item.name} <KeyboardArrowDownIcon /></Button>;
                } else {
                    //mobile heading
                    el = <MenuItem key={item.id} className={classes.menuLabel}>{item.name}</MenuItem>;
                }
            } else {
                if (!item.isChild) {
                    if (!mobile) {
                        //desktop main
                        el = <Link key={item.id} to={route} className={classes.menuItem} tabIndex="0" onClick={handleClose}>{item.name}</Link>;
                    } else {
                        //mobile main
                        el = <MenuItem key={item.id} className={classes.menuLabel}
                            component={Link} to={route} onClick={toggleMobile(false)} tabIndex="0">
                            {item.name}</MenuItem>;
                    }
                } else {
                    if (!mobile) {
                        //desktop sub
                        el = <MenuItem key={item.id} className={classes.menuLabel} 
                            component={Link} to={route} onClick={handleClose}>
                            {item.name}</MenuItem>;
                    } else {
                        //mobile sub
                        el = <MenuItem key={item.id} className={classes.menuLabel + " " + classes.menuSubLabel}
                            component={Link} to={route} tabIndex="0" onClick={toggleMobile(false)}>
                            {item.name}</MenuItem>;
                    }
                }
            }
        } else {
            if (!mobile) {
                //desktop external
                if (item.isChild) {
                    el = <MenuItem key={item.id} className={classes.menuLabel}
                        component="a" target="_blank" href={item.url} onClick={handleClose}>
                        {item.name}</MenuItem>;
                } else {
                    el = <a key={item.id} href={item.url} className={classes.menuItem} target="_blank" tabIndex="0" onClick={handleClose}>{item.name}</a>;
                }
            } else {
                //mobile external
                if (item.isChild) {
                    el = <MenuItem key={item.id} className={classes.menuLabel + " " + classes.menuSubLabel}
                        component="a" target="_blank" href={item.url} tabIndex="0" onClick={handleClose}>
                        {item.name}</MenuItem>;
                } else {
                    el = <MenuItem key={item.id} className={classes.menuLabel}
                        component="a" target="_blank" href={item.url} tabIndex="0" onClick={handleClose}>
                        {item.name}</MenuItem>;
                }

            }
        }

        return el;
    };
    const renderMenu = (mobile = false) => {
        let out = [];
        if(navItems)
        for (var i = 0; i < navItems.length; i++) {
            if (mobile || !navItems[i].isChild) {
                out.push(renderMenuItem(i, mobile));
            }
        }
        return out;
    };
    const renderMenuPopup = () => {
        let out = [];
        switch (whichMenu) {
            case "account":
                if (auth.user?.id) {
                    out.push(<MenuItem key="1" className={classes.menuLabel} onClick={handleLogout} role="button">Log out</MenuItem>);
                    if (auth.user.id && auth.user.roles && auth.user.roles.indexOf("admin") > -1) {
                        out.push(<ListSubheader key="2" className={classes.menuLabelHeading}>Administration</ListSubheader>);
                        out.push(<MenuItem key="3" className={classes.menuLabel} component={Link} to={'/users'} onClick={handleClose}>Users</MenuItem>);
                        out.push(<MenuItem key="4" className={classes.menuLabel} component={Link} to={'/tags'} onClick={handleClose}>Tags</MenuItem>);
                        out.push(<MenuItem key="5" className={classes.menuLabel} component={Link} to={'/settings'} onClick={handleClose}>Site Settings</MenuItem>);
                        out.push(<MenuItem key="6" className={classes.menuLabel} component={Link} to={'/template'} onClick={handleClose}>Page Templates</MenuItem>);
                    }
                    if (auth.user.id && auth.user.roles && (auth.user.roles.indexOf("page.contributor") > -1 || auth.user.roles.indexOf("page.approver") > -1)) {
                        out.push(<MenuItem key="7" className={classes.menuLabel} component={Link} to={'/page'} onClick={handleClose}>Loose pages</MenuItem>);
                    }
                    if (auth.user.id && auth.user.roles && (auth.user.roles.indexOf("unlisted.contributor") > -1 || auth.user.roles.indexOf("unlisted.approver") > -1)) {
                        out.push(<MenuItem key="8" className={classes.menuLabel} component={Link} to={'/unlisted'} onClick={handleClose}>Unlisted pages</MenuItem>);
                    }
                    if (auth.user.id && auth.user.roles && auth.user.roles.indexOf("admin") > -1) {
                        out.push(<MenuItem key="9" className={classes.menuLabel} component={Link} to={'/glossary'} onClick={handleClose}>Glossary</MenuItem>);
                        out.push(<MenuItem key="10" className={classes.menuLabel} component={Link} to={'/nav'} onClick={handleClose}>Navigation</MenuItem>);
                    }
                    
                    if (auth.user.id && auth.user.roles && auth.user.roles.find((r) => r.endsWith(".contributor"))) {
                        out.push(<MenuItem key="11" className={classes.menuLabel} component={Link} to={'/filemanager'} onClick={handleClose}>File Manager</MenuItem>);
                    }

                    if (auth.user.id && auth.user.roles && auth.user.roles.indexOf("admin") > -1) {
                        out.push(<MenuItem key="12" className={classes.menuLabel} component={Link} to={'/trash'} onClick={handleClose}>Recycling bin</MenuItem>);
                    }
                    if (auth.user.id && auth.user.roles && auth.user.roles.indexOf("data/reporting") > -1) {
                        out.push(<MenuItem key="13" className={classes.menuLabel} component={Link} to={'/logs'} onClick={handleClose}>Logs</MenuItem>);
                    }
                    if (auth.user.id && auth.user.roles && auth.user.roles.indexOf("admin") > -1) {
                        out.push(<MenuItem key="14" className={classes.menuLabel} component={Link} to={'/pageattendances'} onClick={handleClose}>Event Completions</MenuItem>);
                    }
                } else {
                    out.push(<MenuItem key="0" className={classes.menuLabel} onClick={handleLogin} role="button">Log in</MenuItem>);
                    out.push(<MenuItem key="-1" className={classes.menuLabel + " " + classes.menuLabelFlex} onClick={sso} role="button">
                        <ListItemIcon className={classes.menuLabelIcon}><MicrosoftLogo fontSize="small" /></ListItemIcon>
                            Microsoft Sign-on
                            {loadingSSO ? <CircularProgress size={24} sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-12px', marginLeft: '-12px', }} /> : null}
                        </MenuItem>);
                }
                break;
            default:
                var whichId = parseInt(whichMenu);
                if (!isNaN(whichId)) {
                    for (var i = whichId + 1; i < navItems.length; i++) {
                        if (navItems[i].isChild) {
                            out.push(renderMenuItem(i, false));
                        } else {
                            break;
                        }
                    }
                }
        }
        return out;
    };
    const isReactSnap = typeof window !== 'undefined' && navigator.userAgent === 'ReactSnap';
    if (isReactSnap)
        return null;
    return (
        <React.Fragment>                
            {/* DESKTOP TOOLBAR */}
            <Toolbar className={classes.toolbar}>
                {/* LOGO */}
                <Box className={classes.fg}>
                    <img src={isDarkMode ? logowhite : logo} alt="UOW logo" className={classes.logo} onClick={() => { setShowLogin(showLogin + 1); }} onTouchEnd={() => { setShowLogin(showLogin + 1); }} /> 
                
                    
                </Box>
                <nav className={classes.toolbarLink}>
                    {renderMenu(false)}
                    
                    {/* SEARCH ICON */}
                    <IconButton disableRipple={true} color="primary" className={classes.iconLabel} onClick={handleShowSearch} tabIndex="0" aria-label="open search">
                        Search&nbsp;<SearchIcon />
                    </IconButton>  
                    {/* THEME TOGGLE */}
                    <ThemeToggle className={classes.iconLabel} />
                    
                    {/* ACCOUNT */}
                    {(showLogin > 5 || auth.user.id) ?
                        <IconButton disableRipple={true} color="primary" className={classes.iconLabel} aria-controls="popup-menu" aria-haspopup="true" aria-label="open account controls" onClick={(e) => handleClick(e, 'account')}><PersonIcon />
                            {auth.user.id ? <span>{auth.user.name}</span>
                                : <span />
                            }</IconButton>
                        : null }
                    {/* SEARCH BAR */}
                    {showSearch ? <SearchBar onSearch={handleSearch} tip={"Search the L&T Hub"} filter={filter} autoFocus={true} fullWidth /> : <Box className={classes.searchBar} />}
                   
                    
                </nav>
               
            </Toolbar>
            {/* MOBILE TOOLBAR */}
            <Toolbar className={classes.toolbarMobile} variant="dense" disableGutters={true} >
               <Box className={classes.toolbarRow}>
                    {/* LOGO */}
                    <Box className={classes.fg}>
                        <img src={isDarkMode ? logoHorizontalWhite : logoHorizontal} alt="UOW logo" onClick={() => { setShowLogin(showLogin + 1); }} onTouchEnd={() => { setShowLogin(showLogin + 1); }} />
                    </Box>        
               
                    {/* ACCOUNT */}
                    
                    {/* FULL MENU */}
                    <Box className={classes.toolbarLinkMobile}>
                        {(showLogin > 5 || auth.user.id) ?
                            <IconButton disableRipple={true} color="primary" className={classes.removePadding + " " + classes.iconLabel} aria-controls="popup-menu" aria-haspopup="true" aria-label="open account controls" onClick={(e) => handleClick(e, 'account')} tabIndex="0"><PersonIcon /></IconButton>
                        : null}
                        <IconButton disableRipple={true} color="primary" className={classes.removePadding + " " + classes.iconLabel} aria-label="open search" onClick={handleShowSearch} tabIndex="0"><SearchIcon /></IconButton>
                        {/* THEME TOGGLE */}
                        <ThemeToggle className={classes.removePadding + " " + classes.iconLabel} />
                        <IconButton disableRipple={true} color="primary" className={classes.removePadding + " " + classes.iconLabel} aria-controls="popup-menu" aria-haspopup="true" aria-label="open main menu" onClick={toggleMobile(true)} tabIndex="0"><MenuIcon /></IconButton>
                   
                    </Box>
                </Box>
              
                {/* SEARCH */}
                {showSearch ?
                    <Box className={classes.toolbarRow}>            
                    <SearchBar fullWidth onSearch={handleSearch} tip={"Search L & T Hub"} filter={filter}
                            startAdornment={<IconButton disableRipple={true} color="primary" className={classes.removePadding} autoFocus={true} onClick={handleShowSearch}><CloseIcon /></IconButton>} />         
                        </Box>
                    :
                    <Box />
                }
              
            </Toolbar>
    
           
            {/* MENU */}
            <Menu
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                id="popup-menu"
                ref={menuRef}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    square: true,
                    elevation: 0,
                    variant: "outlined",
                    className: classes.navPopup
                }}
                getContentAnchorEl={null}
            >
                {renderMenuPopup()}
            </Menu>
            <SwipeableDrawer className={classes.sectionMobile} id="filter-drawer" anchor='right' open={mobileOpen} onClose={toggleMobile(false)} onOpen={toggleMobile(true)}>
                <Box className={classes.b1}>
                    <Typography variant="h2" gutterBottom tabIndex={-1}>Menu</Typography>
                    <IconButton aria-label="close menu" aria-controls="filter-drawer" onClick={toggleMobile(false)} color="inherit"><Clear /></IconButton>
                </Box>
                <nav>{renderMenu(true)}</nav>
            </SwipeableDrawer>
            <Login embed={true} open={login} onLogin={onLogin} canCancel={true} />
        </React.Fragment>
    );
}